import React, { useState } from "react";
import clsx from "clsx";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Typography from "../Typography";
import ITransferPhasebar from "./TransferPhasebar";
import { MHWhiteLogo, MoneyhopLogo } from "../../../assets/Icons";
import Modal from "../Modal";
import Checkbox from "../Checkbox";
import Button from "../Button";

export const TransferPhasebar: React.FC<ITransferPhasebar.IProps> = ({
  data,
  activeStepNumber,
  transactionMode,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [cancellationReasons, setCancellationReasons] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");
  const TransactioncancellationReasons = [
    "Do not have documents yet",
    "Just trying the platform",
    "Connectivity issue",
    "Other Reason...",
  ];

  return (
    <div className="flex flex-col items-center h-full z-50">
      <div className="flex flex-col items-center w-full">
        <div className="flex items-center bg-primary-1050 w-full">
          <div className="flex items-center justify-around w-full px-8 self-center min-w-[1240px]">

            <div className="flex flex-col items-center">
              {/* <MHWhiteLogo fillColor="bg-primary-1050" /> */}
              <MoneyhopLogo />
              {/* {transactionMode && (
            <div className=" text-white  p-2 rounded-md text-[20px] font-bold underline">
              {transactionMode === "Offline"
                ? " Offline"
                : transactionMode === "Flywire"
                  ? " Offline"
                  : transactionMode === "Online"
                    ? " Online Transaction"
                    : transactionMode === "Travel Card"
                      ? " Travel Card"
                      : ""}
            </div>
          )} */}
            </div>

          </div>
        </div>
        {/* {transactionMode && (
          <div className="mt-10 text-white text-[20px] font-bold">
            {transactionMode === "Offline"
              ? "moneyHOP Offline"
              : transactionMode === "WesternUnion"
              ? "Western Union Offline"
              : transactionMode === "Flywire"
              ? "Flywire Offline"
              : ""}
          </div>
        )} */}
        <div className="flex items-center my-6 max-w-[1240px] w-full">
          <button
            onClick={() => {
              const currentIndex = data.findIndex((item) => item.id === activeStepNumber);
              const previousStep = data[currentIndex - 1];
              if (previousStep) {
                navigate(previousStep.pathName);
              }
            }}
            className={activeStepNumber === 1 ? "cursor-not-allowed opacity-15 -mt-[2%] " : "text-white-100 font-medium text-2xl hover:underline -mt-[2%] p-2 rounded-md"}
            disabled={activeStepNumber === 1}
          >
            {/* Go Back */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="black" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
          </button>

          <ul role="list" className="flex flex-row items-center justify-center space-x-24 w-full">
            {data.map((value, index) => (
              <li key={index}>
                <div className="relative">
                  {index !== data.length - 1 ? (
                    <span
                      className={clsx(
                        value.id < activeStepNumber ? "bg-primary-1050" : "bg-primary-1100",
                        "absolute top-4 left-8 w-[160px] h-0.5",
                      )}
                      aria-hidden="true"
                    />
                  ) : null}
                  <div className="relative flex flex-col items-center">
                    <div
                      className={clsx(
                        value.id <= activeStepNumber ? "bg-primary-1050" : "bg-primary-1100",
                        "h-8 w-8 rounded-full flex items-center justify-center mr-8",
                      )}
                    >
                      <Typography
                        tagType="div"
                        text={value.id}
                        className={clsx(
                          value.id <= activeStepNumber ? "text-white" : "text-primary-1050",
                          "font-medium text-sm",
                        )}
                      />
                    </div>
                    <Link to={value?.id <= activeStepNumber ? value.pathName : location?.pathname}>
                      <div
                        className={clsx(
                          value?.id <= activeStepNumber ? "cursor-pointer" : "cursor-not-allowed",
                          "text-sm font-medium text-primary-1050 hover:scale-110 transition-all -ml-6 mt-2",
                        )}
                      >
                        {value.phaseName}
                      </div>
                    </Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <button
            onClick={() => setIsModalOpen("cancelReasons")}
            className="text-primary-1050 font-medium text-2xl hover:underline p-2 rounded-md -mt-[2%] !mr-2"
          >
            {/* Cancel Transaction */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 256 256"
              fill="currentColor"
            >
              <g transform="scale(2.81)">
                <path
                  d="M 24.959 68.04 c -0.768 0 -1.536 -0.293 -2.121 -0.879 c -1.172 -1.171 -1.172 -3.071 0 -4.242 l 40.081 -40.081 c 1.172 -1.172 3.07 -1.172 4.242 0 c 1.172 1.171 1.172 3.071 0 4.242 L 27.081 67.161 C 26.495 67.747 25.727 68.04 24.959 68.04 z"
                  fill="red"
                />
                <path
                  d="M 65.04 68.04 c -0.768 0 -1.535 -0.293 -2.121 -0.879 L 22.838 27.081 c -1.172 -1.171 -1.172 -3.071 0 -4.242 c 1.171 -1.172 3.071 -1.172 4.242 0 l 40.081 40.081 c 1.172 1.171 1.172 3.071 0 4.242 C 66.575 67.747 65.808 68.04 65.04 68.04 z"
                  fill="red"
                />
                <path
                  d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 6 C 23.495 6 6 23.495 6 45 s 17.495 39 39 39 s 39 -17.495 39 -39 S 66.505 6 45 6 z"
                  fill="red"
                />
              </g>
            </svg>
          </button>
        </div>
      </div >
      <Modal
        header="Cancel Transaction"
        headerClass={"text-white"}
        modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancelReasons"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="flex flex-col items-center px-5 py-10 space-y-6">
          <span className="font-ssp text-[18px] ">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex justify-center w-full space-x-5">
            <button
              onClick={() => navigate("/home")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        header="Reason for cancellation"
        headerClass={"bg-white !my-0 py-6 px-12 font-bold text-lg"}
        modalClass="!p-0 !rounded !overflow-hidden lg:mb-20 !w-full lg:!w-auto"
        visible={isModalOpen === "oldModal"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="px-5 pb-5">
          {TransactioncancellationReasons.map((data, index) => {
            return (
              <div className="space-x-2 px-7 border-b-[1px] py-6 first:pt-0" key={index}>
                <Checkbox
                  label={data}
                  value={data}
                  name={"cancellationReason"}
                  handleChange={(e) => {
                    setCancellationReasons(e.target.value);
                  }}
                  checkboxClassname="!mr-4"
                />
              </div>
            );
          })}
          {cancellationReasons === "Other Reason..." && (
            <div className="flex items-center justify-center mt-2">
              <textarea
                name="otherReasonDescription"
                value={otherReason}
                rows={4}
                cols={50}
                placeholder="Write your reason here....."
                onChange={(e) => {
                  setOtherReason(e.target.value);
                }}
                className="w-full p-3 bg-white-100 focus-visible:border-0 placeholder:text-center"
              />
            </div>
          )}
          <div className="flex items-center justify-center mt-7 px-[78px]">
            <Button
              bgColor={`${cancellationReasons === "" ? "bg-grey-350" : "bg-primary"}`}
              fontStyle={{
                fontFamily: "",
                fontSize: "text-lg",
                fontWeight: "font-bold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderWidth: "border-none",
                borderRadius: "rounded-[100px]",
              }}
              disabled={cancellationReasons === ""}
              className={"py-3 px-28"}
              onClickHandler={() =>
                cancellationReasons !== "" && cancellationReasons === "Other Reason..."
                  ? otherReason !== "" && navigate("/")
                  : navigate("/")
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
      {/* <div className="mx-auto w-[318px] py-2 flex items-center justify-center text-primary-1050 bg-white cursor-pointer">
        <a
          className="font-medium text-[18px]"
          href="https://www.moneyhop.co/contact/"
        >
          Need Help? Contact moneyHop Support
        </a>
      </div> */}
    </div >
  );
};
